import React from 'react';
import { ErrorGeneric as ErrorGenericPlugin } from '@leverege/molten/imagine';
import { VehicleExists } from './types';
import { vehicleExistsAtDealership, vehicleOwnedByCustomer } from './Templates';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  component: ErrorGenericClass
} = ErrorGenericPlugin;
function VehicleErrors(props) {
  const {
    error
  } = props;

  // A consumer already owns this vehicle
  if (error.status === 400 && error.code === 1) {
    return /*#__PURE__*/_jsx(VehicleExists, {
      ...props,
      errorTitle: "Cannot create vehicle",
      errorBody: "It looks like this vehicle already belongs to a customer",
      supportTemplate: vehicleOwnedByCustomer
    });
  }
  if (error.status === 403 && error.message?.endsWith('is used by another device')) {
    return /*#__PURE__*/_jsx(VehicleExists, {
      ...props,
      errorTitle: "Cannot create vehicle",
      errorBody: "It looks like this vehicle already exists in this or another dealer's system",
      supportTemplate: vehicleExistsAtDealership
    });
  }
  return /*#__PURE__*/_jsx(ErrorGenericClass, {
    ...props
  });
}
export default {
  id: 'recovr.BlueprintFormError.vehicle',
  matches: {
    objectType: 'vehicle'
  },
  sort: 'a',
  component: VehicleErrors
};